import React from 'react';

const ListContext = React.createContext({});

export default ListContext;
